export default "__VITE_ASSET__4ccc3f9e__"